import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheCategoriesLabels',
  props: {
    categories: {
      default: function _default() {
        return [];
      }
    },
    hasScrollOnUnmount: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var categoriesEnhanced = computed(function () {
      var _props$categories;
      return (_props$categories = props.categories) === null || _props$categories === void 0 ? void 0 : _props$categories.map(function (cat) {
        var _cat$id, _cat$sys;
        return {
          link: app.localePath({
            name: 'products-slug',
            params: {
              slug: cat.slug
            }
          }),
          displayedLabel: cat.label || cat.name || cat.title,
          key: (_cat$id = cat.id) !== null && _cat$id !== void 0 ? _cat$id : (_cat$sys = cat.sys) === null || _cat$sys === void 0 ? void 0 : _cat$sys.id
        };
      });
    });
    onBeforeUnmount(function () {
      if (!props.hasScrollOnUnmount) return;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    return {
      __sfc: true,
      props: props,
      isMobile: isMobile,
      app: app,
      categoriesEnhanced: categoriesEnhanced,
      NativeCarousel: NativeCarousel,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});